// Copyright 2016 Sorama B.V.

/* tslint: disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v7.7.6173.30627 (NJsonSchema v5.19.6171.28316) (http://NSwag.org)
// </auto-generated>
//----------------------

export interface DeviceProperties {}

export interface WebCamDeviceProperties extends DeviceProperties {
    focalX: number;
    focalY: number;
    principalX: number;
    principalY: number;
    cropToWideScreen: boolean;
    sensorOffsetCorrectionX: number;
    sensorOffsetCorrectionY: number;
    imageOrientation: WebcamImageOrientation;
}

export interface StreamProperties {
    deviceKey: string;
}

export interface AudioStreamProperties extends StreamProperties {
    windowSize: number;
    decimationNormalisationFactor: number;
    fixedPointFraction: number;
    sampleRate?: number;
    channelSelection?: boolean[];
    useReferenceMicrophone: boolean;
    lowBandwidthMode: boolean;
    orderMode?: OrderMode;
    storageSize: number;
}

export type VideoStreamProperties = StreamProperties;

export interface MotionDevice {
    id: string;
    name: string;
    range: Point3D;
    isHomed: boolean;
}

export interface Point3D {
    x: number;
    y: number;
    z: number;
}

export interface BeamformingProjectionSetSharedAnalysisProperties {
    requestedMicrophones?: Point3D[];
    targetPoints: Point3D[];
}

export interface BeamformingProjectionSetAnalysisProperties extends BeamformingProjectionSetSharedAnalysisProperties {
    frameProperties: BeamformingProjectionAnalysisProperty[];
}

export interface MeasurementBeamformingProjectionSetAnalysisProperties extends BeamformingProjectionSetAnalysisProperties {
    measurement: GenericMeasurement;
}

export interface MongoDocument {
    id: string;
}

export interface GenericMeasurement extends MongoDocument {
    name?: string;
    notes?: string;
    projectId: string;
    start: Date;
    created: Date;
    uraProperties?: URAProperties;
    duration: number;
    distance?: number;
    mutedSensors?: Point3D[];
    parts?: MeasurementPart[];
    metadata?: { [key: string]: any };
    computedMeasurementProperties?: ComputedMeasurementProperties;
    selectedImage?: string;
    isComputedMeasurement: boolean;
    computedMeasurementSourceId?: string;
    computedMeasurementSource?: GenericMeasurement;
}

export interface URAProperties {
    width: number;
    height: number;
    sensorWidth: number;
    sensorHeight: number;
    spacing: number;
}

export interface MeasurementPart {
    measurementType: MeasurementPartType;
    position?: Point3D;
    device?: MeasurementDevice;
    dataHash?: string;
    dataSize?: number;
    dataContainer?: string;
}

export enum MeasurementPartType {
    Audio = <any>"Audio",
    Video = <any>"Video",
}

export interface MeasurementDevice {
    hardwareModuleIds?: number[];
    sensorPositions?: Point3D[];
    sampleRate: number;
    properties: DeviceProperties;
}

export enum WebcamImageOrientation {
    Default = <any>"Default",
    Rotate90 = <any>"Rotate90",
    Rotate180 = <any>"Rotate180",
    Rotate270 = <any>"Rotate270",
}

export interface ComputedMeasurementProperties {
    ProcessorType?: string;
    Properties?: { [key: string]: any };
}

export interface BeamformingProjectionAnalysisProperty {
    frequencies: Range[];
    timeInterval?: Range;
}

export interface Range {
    from: number;
    to: number;
}

export interface AnalysisSetResultOfBeamformingProjectionSetSharedAnalysisPropertiesAndBeamformingProjectionSetProjectionAndBeamformingProjectionAnalysisPropertyAndSingleOf {
    Properties?: BeamformingProjectionSetSharedAnalysisProperties;
    Results?: BeamformingProjectionSetProjection[];
}

export type BeamformingProjectionSet =
    AnalysisSetResultOfBeamformingProjectionSetSharedAnalysisPropertiesAndBeamformingProjectionSetProjectionAndBeamformingProjectionAnalysisPropertyAndSingleOf;

export interface AnalysisResultOfBeamformingProjectionAnalysisPropertyAndSingleOf {
    properties: BeamformingProjectionAnalysisProperty;
    data: number[];
}

export type BeamformingProjectionSetProjection = AnalysisResultOfBeamformingProjectionAnalysisPropertyAndSingleOf;

export interface TimeSignalAnalysisProperties {
    requestedMicrophone?: Point3D;
    properties?: TimeSignalAnalysisProperty[];
}

export interface MeasurementTimeSignalAnalysisProperties extends TimeSignalAnalysisProperties {
    measurement?: GenericMeasurement;
}

export interface TimeSignalAnalysisProperty {
    timeRange?: Range;
}

export interface AnalysisResultOfTimeSignalAnalysisPropertyAndTimeSamplePairOf {
    properties: TimeSignalAnalysisProperty;
    data: TimeSamplePair[];
}

export type TimeSignal = AnalysisResultOfTimeSignalAnalysisPropertyAndTimeSamplePairOf;

export interface TimeSamplePair {
    x: number;
    y: number;
}

export interface SpectrumAnalysisProperties {
    requestedMicrophones?: Point3D[];
    properties: SpectrumAnalysisProperty[];
}

export interface MeasurementSpectrumAnalysisProperties extends SpectrumAnalysisProperties {
    measurement: GenericMeasurement;
}

export interface SpectrumAnalysisProperty {
    timeRange?: Range;
}

export interface AnalysisResultOfSpectrumAnalysisPropertyAndTimeFrequencyPairOf {
    properties: SpectrumAnalysisProperty;
    data: TimeFrequencyPair[];
}

export type Spectrum = AnalysisResultOfSpectrumAnalysisPropertyAndTimeFrequencyPairOf;

export interface Point2D {
    x: number;
    y: number;
}

export type TimeFrequencyPair = Point2D;

export interface SpectrumSetSharedAnalysisProperties {
    requestedMicrophones?: Point3D[];
    duration: number;
}

export interface SpectrumSetAnalysisProperties extends SpectrumSetSharedAnalysisProperties {
    timeOffsets: number[];
}

export interface MeasurementSpectrumSetAnalysisProperties extends SpectrumSetAnalysisProperties {
    measurement: GenericMeasurement;
}

export interface AnalysisSetResultOfSpectrumSetSharedAnalysisPropertiesAndSpectrumSetSpectrumAndSpectrumSetSpectrumPropertiesAndSingleOf {
    Properties?: SpectrumSetSharedAnalysisProperties;
    Results?: SpectrumSetSpectrum[];
}

export type SpectrumSet =
    AnalysisSetResultOfSpectrumSetSharedAnalysisPropertiesAndSpectrumSetSpectrumAndSpectrumSetSpectrumPropertiesAndSingleOf;

export interface AnalysisResultOfSpectrumSetSpectrumPropertiesAndSingleOf {
    properties: SpectrumSetSpectrumProperties;
    data: number[];
}

export type SpectrumSetSpectrum = AnalysisResultOfSpectrumSetSpectrumPropertiesAndSingleOf;

export interface SpectrumSetSpectrumProperties {
    timeRange?: Range;
}

export interface HologramSetSharedAnalysisProperties {
    requestedMicrophones?: Point3D[];
    timeInterval?: Range;
}

export interface HologramSetAnalysisProperties extends HologramSetSharedAnalysisProperties {
    frequencyRanges: Range[];
}

export interface MeasurementHologramSetAnalysisProperties extends HologramSetAnalysisProperties {
    measurement: GenericMeasurement;
}

export interface PsychoAcousticsAnalysisProperties {
    requestedMicrophone: Point3D;
}

export interface MeasurementPsychoAcousticsProperties extends PsychoAcousticsAnalysisProperties {
    measurement: GenericMeasurement;
}

export interface MetricPsychoAcousticsProperties extends PsychoAcousticsAnalysisProperties {
    metricName: string;
}

export interface MeasurementMetricPsychoAcousticsProperties extends MetricPsychoAcousticsProperties {
    measurement: GenericMeasurement;
}

export interface AnalysisSetResultOfHologramSetSharedAnalysisPropertiesAndHologramSetHologramAndHologramSetHologramPropertiesAndComplexOf {
    Properties?: HologramSetSharedAnalysisProperties;
    Results?: HologramSetHologram[];
}

export type HologramSet =
    AnalysisSetResultOfHologramSetSharedAnalysisPropertiesAndHologramSetHologramAndHologramSetHologramPropertiesAndComplexOf;

export interface AnalysisResultOfHologramSetHologramPropertiesAndComplexOf {
    properties: HologramSetHologramProperties;
    data: Complex[];
}

export type HologramSetHologram = AnalysisResultOfHologramSetHologramPropertiesAndComplexOf;

export interface HologramSetHologramProperties {
    frequency: number;
}

export interface Complex {
    re: number;
    im: number;
}

export interface TimeStampModelBase {
    time: number;
}

export interface VideoFrame extends TimeStampModelBase {
    data?: string;
}

export interface VersionInfo {
    IsOptional: boolean;
    DownloadUri?: string;
    Version?: string;
    MD5?: string;
}

export interface StorageInfo {
    size: number;
    freeSpace: number;
    measurements?: StorageEntry[];
    recordings?: StorageEntry[];
}

export interface StorageEntry {
    Name?: string;
    Size: number;
}

export interface AcquisitionServiceSettings {
    storagePath?: string;
    manualIPAdresses?: string[];
}

export interface CaptureDevice {
    name: string;
    vendorId: number;
    productId: number;
    isNetworkDevice: boolean;
    uri: string;
    cropToWideScreen: boolean;
    position?: Point3f;
    calibration?: CaptureDeviceCalibration;
    sensorOffsetCorrection?: CaptureDeviceSensorOffsetCorrection;
    imageRotation: CaptureDeviceImageRotation;
    id: string;
}

export interface ValueType {}

export interface Point3f extends ValueType {
    X: number;
    Y: number;
    Z: number;
}

export interface CaptureDeviceCalibration {
    focalX: number;
    focalY: number;
    principalX: number;
    principalY: number;
}

export interface CaptureDeviceSensorOffsetCorrection {
    x: number;
    y: number;
}

export enum CaptureDeviceImageRotation {
    Default = <any>"Default",
    Rotate90 = <any>"Rotate90",
    Rotate180 = <any>"Rotate180",
    Rotate270 = <any>"Rotate270",
}

export interface PositionedDeviceOfCaptureDevice {
    device: CaptureDevice;
    position: Point3f;
}

export type PositionedCaptureDevice = PositionedDeviceOfCaptureDevice;

export interface FrontEnd {
    id: string;
    frontEndConnectors?: FrontEndConnector[];
    supportedSampleRates?: number[];
    connectorCount: number;
    microphoneCount: number;
    microphonePositions?: Point3f[];
    name: string;
    supportedFeatures?: FrontEndFeatures[];
}

export interface FrontEndConnector {
    connectionInfo?: string;
    broadcastDomain?: string;
    id?: string;
    microphoneArrayIds?: string[];
    microphoneCount: number;
    sensorCalibrations?: SensorCalibration[];
    version?: string;
}

export interface SensorCalibration {
    sensorArrayId?: string;
    calibrationData?: number[];
}

export enum FrontEndFeatures {
    UniformMicrophoneArray = <any>"UniformMicrophoneArray",
    ReferenceMicrophone = <any>"ReferenceMicrophone",
    Webcam = <any>"Webcam",
    NoSynchronisation = <any>"NoSynchronisation",
    NTPSynchronisation = <any>"NTPSynchronisation",
    PTPSynchronisation = <any>"PTPSynchronisation",
    ExternalSynchronisation = <any>"ExternalSynchronisation",
    FixedPoint16Bit = <any>"FixedPoint16Bit",
    Timestamping = <any>"Timestamping",
}

export interface PositionedDeviceOfFrontEnd {
    device: FrontEnd;
    position: Point3f;
}

export type PositionedFrontEnd = PositionedDeviceOfFrontEnd;

export interface Container {
    id: string;
    created: Date;
    contents?: string[];
    metadata?: any;
}

export interface MD5FileHash {
    hash: string;
    size: number;
}

export interface ReorderProperties {
    inputFiles?: InputFileProperties[];
    outputFileName?: string;
}

export interface InputFileProperties {
    id: string;
    filename?: string;
    takeBytesPattern?: number[];
    skipBytesPattern?: number[];
    startByte: number;
    byteLength: number;
}

export interface StreamPropertiesSet {
    properties: StreamProperties[];
}

export enum OrderMode {
    LeftToRightThenTopToBottom = <any>"LeftToRightThenTopToBottom",
    LeftToRightThenBottomToTop = <any>"LeftToRightThenBottomToTop",
    Sampler = <any>"Sampler",
}

export interface MeasurementStatus {
    state: MeasurementState;
    issues?: MeasurementHealthIssue[];
    bufferedDuration: number;
}

export enum MeasurementState {
    Measuring = <any>"Measuring",
    Cancelled = <any>"Cancelled",
    Faulted = <any>"Faulted",
}

export interface MeasurementHealthIssue {
    type: MeasurementHealthIssueType;
    description?: string;
}

export enum MeasurementHealthIssueType {
    InsufficientThroughput = <any>"InsufficientThroughput",
    LowOnMemory = <any>"LowOnMemory",
    HighCPULoad = <any>"HighCPULoad",
}

export interface StreamHologramProperties {
    frequencies: Range[];
}

export interface TimeStampModel {
    time: number;
}

export interface StreamHologram extends TimeStampModel {
    width: number;
    height: number;
    properties?: StreamHologramProperties;
    data?: number[];
}

export interface StreamSpectrumProperties {
    windowSize: number;
}

export interface StreamSpectrum extends TimeStampModelBase {
    properties?: StreamSpectrumProperties;
    dataPoints?: TimeFrequencyPair[];
}

export interface StreamBeamformingProjectionProperties {
    frequencies: Range[];
    targetPoints: Point3D[];
}

export interface StreamBeamformingProjection extends TimeStampModel {
    properties?: StreamBeamformingProjectionProperties;
    data?: number[];
}

export interface Resolution {
    width: number;
    height: number;
}

export interface Region {
    centerX: number;
    centerY: number;
    width: number;
    height: number;
}
